import React from 'react'
import { FormNewTags } from '../../../../../../shared/form-new/form-tags'
import { normalizeEmail } from './fields'

// The test allowlist. The section's lede explains it: while it has
// addresses, only these people are sent to this connection. Staff only,
// except on a connection an organization runs itself (ownerName: its own, on
// the shared app), whose admins change the same list on its connection page
// (auth's PUT /org-sso/connections/:id/test-allowlist); the section says so.
export const SectionTesting = ({ ownerName }) =>
  <div style={{ maxWidth: 560 }}>
    <FormNewTags name="testAllowlist" label="Test addresses" normalize={normalizeEmail} placeholder="Add an email address and press Enter" />
    {ownerName && <p className="sw-hint mt-2 mb-0" data-testid="testing-owner-note">{ownerName} owns this connection, so its admins can change this list too, on its connection page.</p>}
  </div>
